<template>
    <div class="expert-box">
        <div class="imgbox">
            <div class="shak">
                <h3 class="caption" v-if='expertData.caption'>{{expertData.caption}}</h3>
            </div>
            <div class="center-box">
                <div class="center">
                    <div class="entitle">{{expertData.entitle}}</div>
                    <div class="cncaption">{{expertData.cncaption}}</div>
                    <p class="cncenter" v-html='expertData.cncenter'></p>
                    <div class="icobox" v-if='expertData.itemData'>
                        <div class="item-box" v-for='(item,index) in expertData.itemData' :key='index'>
                            <div class="item-ico" :style='{backgroundImage:"url("+item.icourl+")"}'></div>
                            <p class="item-title" v-html='item.title'></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Expert',
        props: {
            expertData: Object
        },
        data() {
            return {

            }
        }
    }
</script>
<style scoped>
    .expert-box {
        padding-bottom: 513px;
    }

    .imgbox {
        height: 923px;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/stock-photo-157397711.jpg') no-repeat center center;
        background-size: cover;
        position: relative;
        background-attachment: fixed;
    }

    .shak {
        background-color: rgba(0, 0, 0, .3);
        min-height: 864px;
        width: 63.9%;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 180px);
        padding: 67px 88px;
    }

    .shak::before {
        content: "LinkedIn";
        display: block;
        position: absolute;
        right: 36px;
        top: 50px;
        font-size: 24px;
        font-family: gilroybold4;
        font-weight: bold;
        line-height: 29px;
        color: rgba(255, 255, 255, 1);
    }

    .caption {
        font-size: 4.166vw;
        font-weight: bold;
        line-height: 140%;
        color: rgba(255, 255, 255, 1);
    }

    .center-box {
        position: absolute;
        bottom: 0;
        left: 50%;
        background-color: #ffffff;
        width: 65.6%;
        min-height: 690px;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translate(-34.62%, 229px);
    }

    .center {
        width: auto;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 3;
    }

    .center-box::before {
        content: '01';
        display: block;
        font-size: 140px;
        font-weight: bold;
        line-height: 169px;
        color: rgba(196, 196, 196, 1);
        position: absolute;
        top: 82px;
        left: 96px;
    }

    .center-box::after {
        content: 'establish';
        display: inline;
        font-size: 120px;
        line-height: 88px;
        font-family: gilroybold4;
        font-weight: bold;
        color: rgba(241, 241, 241, 1);
        text-transform: uppercase;
        position: absolute;
        bottom: 0;
        right: 0;
        transform: translateY(112%) rotate(90deg);
        transform-origin: right top;
    }


    .entitle {
        font-size: 24px;
        font-family: gilroybold4;
        font-weight: bold;
        line-height: 29px;
        color: rgba(36, 136, 248, 1);
    }

    .cncaption {
        font-size: 42px;
        font-weight: bold;
        line-height: 59px;
        color: rgba(51, 51, 51, 1);
    }

    .cncenter {
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        color: rgba(153, 153, 153, 1);
        max-width: 553px;
        margin: 8px 0 52px 0;
    }

    .icobox {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 62px;
        grid-row-gap: 56px;
        width: 574px;
    }

    .item-ico {
        width: 28px;
        height: 28px;
        margin-bottom: 12px;
        background: transparent no-repeat center;
        background-size: cover;
    }

    .item-title {
        font-size: 16px;
        font-weight: 400;
        color: rgba(112, 112, 112, 1);
    }

    @media(max-width: 995px) {
        .imgbox {
            height: auto;
            background-attachment: initial;
        }
        .expert-box {
        padding-bottom:10%;
    }

        .shak::before {

            right: 0px;
            top: 5%;
            font-size: 24px;
            line-height: 120%;
        }

        .shak {
            background-color: rgba(0, 0, 0, .3);
            min-height: auto;
            width: 100%;
            position: static;
            left: 0%;
            bottom: 0;
            transform: translate(0%, 0%);
            padding: 20% 0;
        }

        .center-box {
            position: sticky;
            background-color: #ffffff;
            width: 100%;
            min-height: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            transform: translate(0%, 0%);
            padding: 5% 0;
        }

        .center-box::before {
            font-size: 150px;
            font-weight: bold;
            line-height: 120%;
            top: 0px;
            left: 0px;
        }

        .center {
            width: 90%;
            height: 100%;
        }

        .center-box::after {
            display: none;
        }

        .caption {
            text-align: center;
            width: 100%;
            font-size: 35px;
            font-weight: bold;
            line-height: 140%;
            color: rgba(255, 255, 255, 1);
        }

        .cncaption {
            font-size: 24px;
            line-height: 140%;
        }
        .cncenter {
        
        line-height: 175%;
        max-width: 100%;
        margin:5% 0;
        color: #333;
    }
    .icobox {
        display: grid;
        grid-template-columns:45% 45%;
        grid-column-gap:10%;
        width:100%;
    }
    }

    /* @media(max-width: 1023px) {
        .imgbox {
            height: 1200px;
            background-attachment: initial;
        }

        .shak {
            background-color: rgba(0, 0, 0, .3);
            height: 1100px;
            width: 100%;
            left: 0;
            transform: translate(0, 20%);
        }

        .center-box {
            position: absolute;
            bottom: 0;
            left: 50%;
            background-color: #ffffff;
            width: 90%;
            min-height: 1300px;
            transform: translate(-50%, 50%);
        }

        .entitle {
            font-size: 40px;
            line-height: 120%;
        }

        .cncaption {
            font-size: 72px;
            line-height: 140%;
        }

        .cncenter {
            font-size: 50px;
            line-height: 175%;
            max-width: 80%;
        }

        .expert-box {
            padding-bottom: 1000px;
        }

        .icobox {
            width: 80%;
        }

        .item-ico {
            width: 60px;
            height: 60px;
        }

        .item-title {
            font-size: 50px;
        }
    }

    @media(max-width: 350px){
        .expert-box {
        padding-bottom: 2513px;
    }
        .center-box {
            min-height: 2500px;
            transform: translate(-50%, 80%);
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/expert.vue